import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import MultiLanguageInput from 'src/components/misc/multi-language-input';

class TemplateEditForm extends Component {
    render() {
        const { handleSubmit, t } = this.props;

        return (
            <form className="form-horizontal" onSubmit={handleSubmit}>
                <input type="hidden" name="name" />

                <div className="row">
                    <div className="col-md-12">
                        <label>{t('common_phrases.text')}</label>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <Field
                            name="text"
                            placeholder={t('common_phrases.text')}
                            label={t('common_phrases.text')}
                            t={t}
                            component={MultiLanguageInput}
                            componentType="renderRichTextEditorMultiLang"
                        />
                    </div>
                </div>
            </form>
        );
    }
}

export default reduxForm({
    form: 'templateEditForm',
})(TemplateEditForm);
